import { createSelector } from 'reselect'
import getIsInsurnaceDomesticTrip from './getIsInsurnaceDomesticTrip'
import { getInsuranceProductListKey } from 'lib/insurance/insuranceUtils'

const getCheckoutInsuranceProductFetchStatus = createSelector(
  (state: App.State) => getIsInsurnaceDomesticTrip(state),
  (state: App.State) => state.insurance.productListErrors,
  (state: App.State) => state.insurance.fetchingProductLists,
  (_: App.State, type?: App.InsuranceProductType) => type,
  (isDomestic, productLists, productListsFetching, type): { fetching: boolean, error?: string } => {
    const key = getInsuranceProductListKey(type ?? 'travel-insurance', {
      isDomestic,
      isCruise: false,
    })
    return {
      fetching: productListsFetching[key],
      error: productLists[key],
    }
  },
)

export default getCheckoutInsuranceProductFetchStatus
